$ = require 'jquery'
Vue = require 'vue'
eventHub = require '../event_hub.coffee'
require '../directives/date_picker.coffee'


services_invoice = new Vue
#  el: '.services-invoice-form-wrapper'
  data: ->
    items: window.services_invoice_items || []
    tax_items: []
    is_ready: false
    contact_id: window.services_invoice_contact_gid
    owner_id: window.services_invoice?.owner_id
    issued_at: window.services_invoice?.issued_at
    reference: window.services_invoice?.reference
    vat: window.services_invoice?.vat
    paid_vat: window.services_invoice?.paid_vat
    discount_tax: window.services_invoice?.discount_tax
    reserved_amount_percent: window.services_invoice?.reserved_amount_percent
    from_purchase: window.services_invoice?.from_purchase
    related_to: window.services_invoice?.related_to
    vat_tax_office_id: window.services_invoice?.vat_tax_office_id
    paid_vat_tax_office_id: window.services_invoice?.paid_vat_tax_office_id
    discount_tax_office_id: window.services_invoice?.discount_tax_office_id


  components:
    'services-invoice-item': require('./components/services-invoice-item.coffee')
#    'services-invoice-tax-item': require('./components/services-invoice-tax-item.coffee')


  created: ->
    eventHub.$on('remove-item', @removeItem)
#    eventHub.$on('remove-tax-item', @removeTaxItem)

    unless @contact_id
      @items.push({amount: 0, description: ''})


  computed:
    items_count: -> @items.length
#    tax_count: -> @tax_items.length

    itemsWithAmount: ->
      @items.filter (i)->
        i.amount isnt null and i.amount > 0 and not i._destroy


    items_total: ->
      t = @itemsWithAmount.reduce (sum, item)->
        sum.plus(item.amount)
      , Big(0)
      t.toFixed(3)


    vat_amount: ->
      vat = round_number(@vat, 2)
      Big(@items_total).times(vat).div(100)

    paid_vat_amount: ->
      if @paid_vat then -@vat_amount else Big(0)


    discount_tax_amount: ->
      discount_tax = round_number(@discount_tax, 2)
      Big(@items_total).times(discount_tax).div(100)

    reserved_amount: ->
      percent = round_number(@reserved_amount_percent, 2)
      Big(@items_total).times(percent).div(100)


    net_total: ->
      t = Big(@items_total).plus(@vat_amount).plus(@paid_vat_amount)
        .minus(@discount_tax_amount)
        .minus(@reserved_amount)
      t.toFixed(3)


    itemsIsValid: ->
      vm = @
      not @itemsWithAmount.some (i)-> not vm.itemIsValid(i)


    hasItems: ->
      @itemsWithAmount.length > 0


    isValidContact: ->
      @contact_id != null and @contact_id isnt ""


    hasVat: ->
      not([null, undefined, ''].includes(@vat)) and (@round_number(@vat) > 0)

    hasDiscountTax: ->
      not([null, undefined, ''].includes(@discount_tax)) and (@round_number(@discount_tax) > 0)

    isValidVatTaxOffice: ->
      return true unless @hasVat
      not [null, undefined, ''].includes(@vat_tax_office_id)

    isValidPaidVatTaxOffice: ->
      return true unless @hasVat and @paid_vat
      not [null, undefined, ''].includes(@paid_vat_tax_office_id)

    isValidDiscountTaxOffice: ->
      return true unless @hasDiscountTax
      not [null, undefined, ''].includes(@discount_tax_office_id)

    isValidRelatedTo: ->
      not [null, undefined, ''].includes(@related_to)

    isValidAttributes: ->
      @isValidContact and @owner_id != null and
        @isValidVatTaxOffice and @isValidPaidVatTaxOffice and
        @isValidDiscountTaxOffice and @isValidRelatedTo


    isValid: ->
      @isValidAttributes and @hasItems


  methods:
    addItem: (event)->
      item = {amount: 0, description: '', notes: ''}
      @items.push item
      event and event.preventDefault()


#    addTaxItem: (event)->
#      item = {amount: 0, description: '', sign: 1}
#      @tax_items.push item
#      event and event.preventDefault()


    removeItem: (data)->
      @items.splice(data.index, 1)


#    removeTaxItem: (data)->
#      @tax_items.splice data.index, 1


    itemIsValid: (item)->
      q = @round_quantity(item.quantity)
      item.product_id isnt null and item.quantity != "" and q isnt 0


  events:
    'remove-item': (index)-> @removeItem(index)
#    'remove-tax_item': (index)-> @removeTaxItem(index)


if document.querySelector('.services-invoice-form-wrapper')
  services_invoice.$mount('.services-invoice-form-wrapper')
